<div class="wifi-loader-overlay" *ngIf="isLoading$ | async">
  <div
    class="wifi-loader-modal"
    [ngStyle]="{
      background: theme?.modal?.bgColor,
      borderRadius: theme?.modal?.borderRadius || '0'
    }"
  >
    <button
      type="button"
      class="wifi-loader-close"
      [ngStyle]="{ color: theme?.modal?.textColor }"
      (click)="close()"
      aria-label="Cerrar"
    >
      ×
    </button>

    <h2
      class="wifi-loader-title"
      [ngStyle]="{ color: theme?.modal?.titleColor }"
    >
      {{ 'wifiConnectionLoader.title' | translate }}
    </h2>

    <div class="wifi-loader-animation">
      <img
        [src]="theme?.wifiLoaderGif"
        alt=""
        class="wifi-loader-gif"
      />
    </div>

    <p
      class="wifi-loader-description"
      [ngStyle]="{ color: theme?.modal?.textColor }"
    >
      {{ 'wifiConnectionLoader.description' | translate }}
    </p>
  </div>
</div>
